export default __webpack_public_path__ + "static/agro-visual-b-c2a812a58ee515809f6c21647c873ba0.svg";